import { CatalogRegionEventPeriod } from 'src/api/response/catalog';
import { parseDate } from 'src/lib/dateStringParser';

export function isRegionItemOnSale(period: CatalogRegionEventPeriod[]) {
  const now = Date.now();

  for (const p of period) {
    const { begin, end } = p;
    const eventBeginDate = parseDate(begin);
    const eventEndDate = parseDate(end);
    if (!eventBeginDate || !eventEndDate) {
      return false;
    }

    // リージョンイベント開始日当日の05:00AM(成長処理が入る時刻)のDateを作る
    eventBeginDate.setHours(5);
    eventBeginDate.setMinutes(0);
    eventBeginDate.setSeconds(0);
    eventBeginDate.setMilliseconds(0);

    // リージョンイベント終了日翌日の05:00AM(成長処理が入る時刻)のDateを作る
    // 現実時間で終了日を過ぎても、終了日翌日の成長処理が入るまでは終了日当日扱いとなる
    eventEndDate.setDate(eventEndDate.getDate() + 1);
    eventEndDate.setHours(5);
    eventEndDate.setMinutes(0);
    eventEndDate.setSeconds(0);
    eventEndDate.setMilliseconds(0);

    if (eventBeginDate.getTime() <= now && now < eventEndDate.getTime()) {
      return true;
    }
  }

  // 当てはまる期間がない場合は期間外とみなす
  return false;
}
